(function ($) {

    $.extend(true, $, {
        cdh: {
            services: {
                accounts: $.cdh.accountsFactory
            }
        }
    });
})(jQuery);